import { IVoucher, RootState } from '@checkout/state';
import * as cx from 'classnames';
import * as React from 'react';
import { ChangeEvent, KeyboardEvent } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CheckoutContextConfig } from '../../../apps/CheckoutApp';
import { voucherTypes } from '../../../config/contextCheckoutConfig';
import messages from '../../../i18n/base-en';
import { addVoucherRequest, removeVoucherRequest } from '../../../reducers/checkout';
import { Button, FieldMessage, InputBox, TextInput, VoucherList } from '../../presentational';
import * as Styles from './Voucher.scss';

interface IOwnProps {
  id: string;
  labelSize?: 'big';
}

interface IConnectedProps {
  vouchers: IVoucher[];
  voucherError?: string;
}

interface IConnectetDispatchProps {
  addVoucherRequest: typeof addVoucherRequest;
  removeVoucherRequest: typeof removeVoucherRequest;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

interface IOwnState {
  isActive: boolean;
  value: string;
}

class Voucher extends React.Component<Props, IOwnState> {

  state: IOwnState = {
    isActive: false,
    value: '',
  };

  toggleActive = () => {
    this.setState({
      isActive: !this.state.isActive,
    });
  }

  handleChange = (event: ChangeEvent<any>) => {
    const { value } = event.target;

    this.setState({
      value,
    });
  }

  addVoucher = () => {
    this.props.addVoucherRequest(this.state.value);
    this.setState({
      value: '',
    });
  }

  // Adding voucher on Enter keyboard key press
  handleKeyboardKeypress = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && this.state.value && this.state.value !== '') {
      event.preventDefault();
      this.addVoucher();
    }
  }

  removeVoucher = (value: string) => {
    this.props.removeVoucherRequest(value);
  }

  render() {
    const { id, vouchers, voucherError, labelSize, intl } = this.props;
    const { isActive, value } = this.state;
    const { formatMessage } = intl;

    const voucherToggleClassNames = cx({
      [Styles.toggleActive]: isActive,
    });

    return (
      <CheckoutContextConfig.Consumer>
        {(checkoutContextConfig => (
          <div className={Styles.wrapper}>
            {checkoutContextConfig.ui.voucher.type === voucherTypes.link && !isActive && (
              <div className={Styles.discountButton} onClick={this.toggleActive}>
                {formatMessage(messages.voucher_switch_button_label)}
              </div>
            )}
            {checkoutContextConfig.ui.voucher.type === voucherTypes.toggle && (
              <div className={voucherToggleClassNames}>
                <InputBox
                  id="voucher_switch_button"
                  name="voucher_switch_button"
                  type="checkbox"
                  checked={isActive}
                  value={isActive}
                  onChange={this.toggleActive}
                  variant="toggle"
                  sizeVariant={labelSize}
                  label={formatMessage(messages.voucher_switch_button_label)}
                />
              </div>
            )}
            {isActive && (
              <div className={Styles.inputWrapper}>
                <div className={Styles.input}>
                  <TextInput
                    id={id}
                    type="text"
                    value={value}
                    variant="simple"
                    onChange={this.handleChange}
                    onKeyPress={this.handleKeyboardKeypress}
                    submitOnEnter={true}
                    autoFocus={isActive}
                    label={formatMessage(messages.voucher_input_label)}
                    placeholder={formatMessage(messages.voucher_input_placeholder)}
                  />
                </div>
                <Button
                  align="left"
                  type="button"
                  label={formatMessage(messages.voucher_apply_button_label)}
                  variant="primary"
                  disabled={!this.state.value || this.state.value === ''}
                  onClick={this.addVoucher}
                />
              </div>
            )}
            {voucherError && <FieldMessage error={true} message={formatMessage(messages.voucher_not_found)} />}
            {vouchers && vouchers.length > 0 && (
              <VoucherList removeLabel={formatMessage(messages.voucher_remove_button_label)} vouchers={vouchers} handleRemove={this.removeVoucher} />
            )}
          </div>
        ))}
      </CheckoutContextConfig.Consumer>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      vouchers: state.checkout.selection.discounts && state.checkout.selection.discounts.vouchers,
      voucherError: state.checkout.voucherError
    }),
    {
      addVoucherRequest,
      removeVoucherRequest
    }
  ),
)(Voucher);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/Voucher/Voucher.tsx